export { VoiceRecorder } from './VoiceRecorder';
export type { VoiceRecorderProps } from './VoiceRecorder';
